/**
 * The Watchtower report's Deck Chat hand-off DRAFT: FROZEN ENGLISH.
 *
 * The report page pre-fills Deck Chat's composer with this text (through
 * react-router navigation state, read back by the deck page's
 * WatchtowerChatHandoff), and whatever the user then sends goes to the model.
 * Deck Chat answers in English this release, and every string it is sent
 * from a canned control is English wire vocabulary ("Frozen English strings"
 * in the Phase 3 localization plan, row `chatHandoffDraft`). So this module
 * never reads a catalog, in any language: a Spanish interface still hands
 * over exactly this English sentence. The button that starts the hand-off is
 * translated (`watchtower:handoff.*`, components/watchtower/reportBits.tsx).
 *
 * Kept apart from lib/watchtowerNudges.ts, whose display copy IS translated,
 * so the frozen sentence cannot drift into a catalog by accident. Pinned by
 * src/lib/__tests__/watchtowerNudges.i18n-on.test.ts (exact English under es).
 */
/* eslint-disable i18next/no-literal-string -- frozen English wire text sent to Deck Chat (see header) */

/** "A", "A and B", "A, B and C". */
export function joinPickNames(names: string[]): string {
  if (names.length <= 1) return names[0] ?? ''
  return `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`
}

/** The composer text Deck Chat is pre-filled with. Never sent on its own. */
export function chatHandoffDraft(names: string[]): string | null {
  if (names.length === 0) return null
  const pronoun = names.length === 1 ? 'it' : 'them'
  return `Watchtower suggested ${joinPickNames(names)} for this deck. How would I fit ${pronoun} in, and what should come out?`
}
